import { client } from '@efex-services/config';

const getPostalCode = async (params?: {
  searchCriteria: string;
}): Promise<IPostalCode[]> => {
  if (params?.searchCriteria) {
    return client.get(
      `/enterprise/address/zip-code?search=${params.searchCriteria}`
    );
  }
  return client.get('/enterprise/address/zip-code');
};

const getCompanySector = async (params?: {
  searchCriteria: string;
}): Promise<ICompanySector[]> => {
  if (params?.searchCriteria) {
    return client.get(
      `/enterprise/company-sector?search=${params.searchCriteria}`
    );
  }
  return client.get('/enterprise/company-sector');
};

const getPostalCodeById = async (id: number): Promise<IPostalCode> =>
  client.get(`/enterprise/address/zip-code?id=${id}`);

const onboardingSvc = {
  getPostalCode,
  getCompanySector,
  getPostalCodeById,
};

export default onboardingSvc;
